import * as ActiveStorage from 'activestorage/src/index';

export const UPLOAD_STATES = {
  IDLE: 'idle',
  UPLOADING: 'uploading',
  SUCCESS: 'success',
  ERROR: 'error'
};

const { IDLE, UPLOADING, SUCCESS, ERROR } = UPLOAD_STATES;

export default class UploadInstance {
  directUpload = null;
  promise = null;

  status = IDLE;

  file = null;
  name = '';

  progress = 0;
  total = 0;

  error = null;
  blob = {};

  onProgress = null;

  constructor({ file, url }) {
    this.file = file;
    this.name = file.name;
    this.type = file.type;
    this.directUpload = new ActiveStorage.DirectUpload(file, url, this);
    this.tempId = `${file.name}_${new Date().getTime()}`;

    this.dataUrl = URL.createObjectURL(file);
  }

  start() {
    this.promise = new Promise((res, rej) => {
      this.status = UPLOADING;

      this.directUpload.create((error, blob) => {
        if (error) {
          this.error = error;
          this.status = ERROR;

          window.bugsnagClient?.notify(error);

          return rej(error, this);
        }

        this.blob = blob;
        this.status = SUCCESS;

        return res(this);
      });
    });

    return this.promise;
  }

  directUploadWillStoreFileWithXHR(req) {
    req.upload.addEventListener('progress', event =>
      this.directUploadDidProgress(event)
    );
  }

  directUploadDidProgress(event) {
    const { total, loaded } = event;
    this.total = total;
    this.progress = loaded / total;

    if (this.onProgress) {
      this.onProgress(this.progress);
    }
  }
}
